const AboutUs = () => {

    return (
        <section id="about_us" className="p-5 bg-secondary text-center text-light">
            <div className="container">
                <h1 className="fw-bold font-link pb-5 pt-5">درباره فــراد</h1>

                <p className="text-center font-link fw-bolder">شرکت فرا رایانه آسان درمان (فــراد) یک شرکت نرم افزاری است که در
                    راستای تسهیل
                    و بهبود خدمات پزشکی و سلامت جامعه فعالیت میکند. اعضای اصلی این شرکت از مهندسان و پزشکان خبره تشکیل
                    شده است و همین موضوع باعث شده که نرم افزار های تولید شده توسط این شرکت منطبق ترین حالت با نیاز
                    پزشکان و سلامت جامعه باشد. در حال حاضر نرم افزار هایی برای مدیریت امور مطب و مدیریت پرونده های پزشکی
                    بیماران همچنین تعامل بیماران با پزشک و پرونده الکترونیک خود در حال ساخت و در مرحله پیش آزمایش می
                    باشد که به زودی ارایه می گردند، همچنین خدمات نوبت دهی آنلاین از پزشکانی که با ما همکاری می کنند به
                    زودی فراهم خواهد شد. امیدواریم که خدمات این شرکت در جهت برطرف کردن نیاز های جامعه پزشکی و
                    سلامت عمومی سود بخش باشد.</p>
            </div>
        </section>
    );


}

export default AboutUs